import type { TDiff } from '6-shared/types'

import React from 'react'
import { initSentry } from '6-shared/helpers/tracking'
import { store } from 'store'
import { bindWorkerToStore } from 'worker'
import { applyClientPatch, resetData } from 'store/data'
import GlobalErrorBoundary from './GlobalErrorBoundary'
import App from './App'
import { Providers } from './Providers'
import { registerSW } from 'virtual:pwa-register'

registerSW({
  immediate: true,
  onRegisterError(error) {
    console.error('SW registration error', error)
  },
})
initSentry()
bindWorkerToStore(store.dispatch)
createEndlessInstance(store)

export const MainApp = () => (
  <GlobalErrorBoundary>
    <Providers store={store}>
      <App />
    </Providers>
  </GlobalErrorBoundary>
)

/** `endless` can be used in console to access state and modify data */
function createEndlessInstance(s: typeof store) {
  let logsShow = localStorage.getItem('showLogs') === 'true'

  // @ts-ignore
  window.endless = {
    get state() {
      return s.getState()
    },
    // @ts-ignore
    env: import.meta.env,
    get logsShow() {
      return logsShow
    },
    toggleLogs: () => {
      logsShow = !logsShow
      localStorage.setItem('showLogs', String(logsShow))
      return logsShow
    },
    logs: {},
    resetData: () => s.dispatch(resetData()),
    applyClientPatch: (patch: TDiff) => s.dispatch(applyClientPatch(patch)),
    showEl: (id: string) => {
      let data = s.getState().data.current
      return (
        Object.values(data)
          // @ts-ignore
          .map(c => c[id])
          .filter(Boolean)[0]
      )
    },
  }
}
